import { Directive, ElementRef, Input, AfterViewInit, OnDestroy } from '@angular/core';

@Directive({
  selector: 'img[appLazyLoad]',
  standalone: true
})
export class LazyImageDirective implements AfterViewInit, OnDestroy {
  @Input() src = '';
  @Input() placeholder = 'assets/images/placeholder.svg';
  @Input() errorImage = 'assets/images/error.svg';

  private observer?: IntersectionObserver;
  private imgElement: HTMLImageElement;

  constructor(private elementRef: ElementRef<HTMLImageElement>) {
    this.imgElement = this.elementRef.nativeElement;
  }

  ngAfterViewInit() {
    // Set placeholder initially
    if (this.placeholder) {
      this.imgElement.src = this.placeholder;
    }

    // Create intersection observer
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.loadImage();
            this.observer?.unobserve(this.imgElement);
          }
        });
      },
      {
        rootMargin: '50px' // Start loading 50px before the image enters the viewport
      }
    );

    this.observer.observe(this.imgElement);
  }

  ngOnDestroy() {
    this.observer?.disconnect();
  }

  private loadImage() {
    if (!this.src) return;

    const img = new Image();

    img.onload = () => {
      this.imgElement.src = this.src;
      this.imgElement.classList.add('loaded');
    };

    img.onerror = () => {
      if (this.errorImage) {
        this.imgElement.src = this.errorImage;
      }
      this.imgElement.classList.add('error');
    };

    img.src = this.src;
  }
}